(() => {
  // app/scripts/components/FormContactValidation.js
  var FormContactValidation = class extends HTMLElement {
    constructor() {
      super();
      this.form = null;
    }
    connectedCallback() {
      this.form = this.querySelector("form") || document.getElementById("idFormContact");
      if (this.form) {
        this.initValidation();
      }
    }
    initValidation() {
      this.form.addEventListener("submit", this.handleSubmit.bind(this));
      const inputs = this.form.querySelectorAll("input, select, textarea");
      inputs.forEach((input) => {
        input.addEventListener("input", () => this.clearError(input));
        input.addEventListener("change", () => this.clearError(input));
      });
    }
    handleSubmit(e) {
      if (!this.form.checkValidity()) {
        e.preventDefault();
        this.clearAllErrors();
        const inputs = this.form.elements;
        let invalidInput = null;
        for (const input of inputs) {
          if (!input.validity.valid) {
            invalidInput = input;
            break;
          }
        }
        if (invalidInput) {
          this.showErrorForInput(invalidInput);
          this.scrollToElement(invalidInput);
          invalidInput.focus();
        }
        setTimeout(() => {
          for (const input of inputs) {
            if (!input.validity.valid) {
              this.showErrorForInput(input);
            }
          }
        }, 100);
        return;
      }
    }
    scrollToElement(element) {
      const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementTop - 100;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
    showErrorForInput(input) {
      const fieldName = input.id;
      this.addErrorBorder(input);
      this.showError(fieldName);
    }
    clearAllErrors() {
      const errorMessages = this.form.querySelectorAll(".error-message");
      errorMessages.forEach((error) => {
        error.classList.add("hidden");
      });
      const inputs = this.form.querySelectorAll("input, select, textarea");
      inputs.forEach((input) => {
        this.removeErrorBorder(input);
      });
    }
    showError(fieldName) {
      const errorElement = this.form.querySelector(`[data-field="${fieldName}"]`);
      if (errorElement) {
        errorElement.classList.remove("hidden");
      }
    }
    clearError(input) {
      const fieldName = input.id;
      const errorElement = this.form.querySelector(`[data-field="${fieldName}"]`);
      if (errorElement) {
        errorElement.classList.add("hidden");
      }
      this.removeErrorBorder(input);
    }
    addErrorBorder(input) {
      input.classList.remove("border-[var(--miscellaneous)]");
      input.classList.add("border-red-500");
    }
    removeErrorBorder(input) {
      input.classList.remove("border-red-500");
      input.classList.add("border-[var(--miscellaneous)]");
    }
  };
  customElements.define("form-contact-validation", FormContactValidation);
})();
